const SET_CARD = (state, obj) => {
  state.card = obj
}

const SET_LIST = (state, obj) => {
  state.list = obj.data.transacoes
  state.pageCount = obj.data.quantidadeDePaginas
}

export default {
  SET_CARD,
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/admin/astroPay/store/mutations.js